<template>
    <div class="faq">
        <div class="static-body-card">
            <div class="faq__contactus">
                <div class="faq__contactus__title">联系我们</div>
                <div class="faq__contactus__top flex flex--justify-between">
                    <div class="faq__contactus__item hover-card clickable flex flex--direction-column flex--align-center" @click="handleGoToInquiry">
                        <v-icon class="faq__contactus__item__icon" type="iconshopping_cart-24px1" size="112"></v-icon>
                        <div class="faq__contactus__item__title">购买咨询</div>
                        <div class="faq__contactus__item__content">点击联系我们的商务去了解你的需求与更多详情</div>
                    </div>
                    <div class="faq__contactus__item hover-card clickable flex flex--direction-column flex--align-center" @click="handleGoToTechSupport">
                        <v-icon class="faq__contactus__item__icon" type="iconbuild_circle-24px" size="112"></v-icon>
                        <div class="faq__contactus__item__title">技术支持</div>
                        <div class="faq__contactus__item__content">点击联系我们的技术专员去解决您的问题与困惑</div>
                    </div>
                </div>
            </div>
            <div class="faq__faq">
                <div class="faq__faq__title">常见问题</div>
                <div v-for="(qcard, indexQcard) in faqs" :key="indexQcard" class="faq__faq__card" :ref="'faq' + indexQcard">
                    <div class="faq__faq__card__title">{{qcard.title}}</div>
                    <div v-for="(item, indexItem) in qcard.items" :key="indexItem">
                        <template v-if="indexItem < 3 || showFaqsFull[indexQcard]">
                            <div class="faq__faq__card__subtitle-container flex">
                                <div class="faq__faq__card__circle q">Q</div>
                                <div class="faq__faq__card__subtitle" v-html="$options.filters.formatTextWithLink(item.q)"></div>
                            </div>
                            <div class="faq__faq__card__answer-container flex">
                                <div class="faq__faq__card__circle a">A</div>
                                <div class="faq__faq__card__content-container">
                                    <div v-for="(c, indexA) in item.a" :key="indexA" class="faq__faq__card__content" v-html="$options.filters.formatTextWithLink(c)"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="qcard.items.length > 3" class="faq__faq__card__toggle flex flex--justify-end" @click="toggleShowFaqsFull(indexQcard)">
                        <v-icon v-if="showFaqsFull[indexQcard]" type="iconexpand_less-24px" right-text="收起" style="color: #7c4dff"></v-icon>                        
                        <v-icon v-else type="iconexpand_more-24px1" right-text="查看更多" style="color: #7c4dff"></v-icon>
                    </div>
                </div>
            </div>
        </div>
        
        <div>
        </div>
    </div>    
</template>

<script>
import faqData from '@/assets/staticData/faq.js';

export default {
    name: 'faq',
    data() {
        return {
            faqs: faqData,
            showFaqsFull: faqData.map(_ => false)
        }
    },
    computed: {
        
    },
    methods: {
        toggleShowFaqsFull(index) {
            const copy = this.showFaqsFull.slice();
            copy[index] = !copy[index];
            this.showFaqsFull = copy;
            if (!copy[index])
                window.scrollTo({
                    left: 0,
                    top: this.$refs[`faq${index}`][0].offsetTop - 60,
                    // behavior: 'smooth'
                });
        },
        handleGoToInquiry() {
            this.$router.push({
                name: 'inquiry'
            });
        },
        handleGoToTechSupport() {
            this.$router.push({
                name: 'techSupport'
            });
        }
    }
}
</script>

<style lang="less">
    @import "static.less";

    @prefix: ~'faq';
    .@{prefix} {
        user-select: none;
        background: #ECEFF1;
        &__contactus {
            &__title {
                margin-top: 4px;
                font-weight: 400;
                font-size: 31px;
                letter-spacing: -0.86;
                line-height: 48px;
                color: rgba(black, 0.54);
            }

            &__item {
                width: 480px;
                height: 280px;
                border-radius: 8px;
                margin-top: 20px;
                box-shadow: 0 0 2px 0 rgba(black, 0.1), 0 2px 2px 0 rgba(black, 0.08), 0 1px 3px 0 rgba(black, 0.16);

                &__icon {
                    margin-top: 24px;
                    color: #51458B;
                }

                &__title {
                    font-weight: 500;
                    font-size: 21px;
                    line-height: 40px;
                    color: #51458B;
                    margin-top: 6px;
                }

                &__content {
                    margin-top: 14px;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24px;
                    color: rgba(black, 0.54);
                }
            }
        }

        &__faq {
            margin-top: 48px;
            &__title {
                font-weight: 400;
                font-size: 31px;
                line-height: 40px;
                letter-spacing: 2;
                color: rgba(black, 0.54);
                margin-bottom: 8px;
            }

            &__card {
                margin-top: 8px;
                background: #ECEFF1;
                border-radius: 8px;
                width: 976px;
                padding: 15px 16px 20px 16px;

                &__title {
                    font-weight: 500;
                    font-size: 21px;
                    line-height: 40px;
                    color: rgba(black, 0.87);
                    margin-bottom: 9px;
                }

                &__subtitle-container {
                    margin-bottom: 8px;
                }

                &__answer-container {
                    margin-bottom: 32px;
                }

                &__circle {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    font-weight: 700;
                    font-size: 14px;
                    text-align: center;
                    vertical-align: middle;
                    line-height: 24px;
                    &.q {
                        background: #867CE9;
                        color: rgba(black, 0.87);
                    }
                    &.a {
                        background: rgba(black, 0.08);
                        color: #867CE9;
                    }
                }

                &__subtitle {
                    margin-left: 16px;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 24px;
                    color: #867CE9;
                }

                &__content-container {
                    margin-left: 16px;
                }

                &__content {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24px;
                    width: 904px;
                    color: rgba(black, 0.54);
                }

                &__toggle {
                    margin-top: -4px;
                    width: 944px;
                    &:hover {
                        cursor: pointer;
                    }

                    &__text {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #7C4DFF;
                        margin-left: 8px;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
    
    .@{prefix} {
        background: white;
        &__contactus {
            margin-top: -48px;
            padding-top: 16px;
            &__top {
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
            }
            &__title {
                margin-top: 4px;
                margin-left: 16px;
                font-size: 21px;
                letter-spacing: -0.86;
                line-height: 28px;
            }

            &__item {
                width: calc(100vw - 32px);
                height: calc((100vw - 32px) * 0.58);
                margin-top: 8px;
                background: white;

                &__icon {
                    margin-top: 12px;
                    color: #51458B;
                }

                &__title {
                    font-weight: 500;
                    font-size: 21px;
                    line-height: 40px;
                    color: #51458B;
                    margin-top: 6px;
                }

                &__content {
                    margin: 6px 0 8px 0;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24px;
                    color: rgba(black, 0.54);
                }
            }
        }

        &__faq {
            margin-top: 48px;
            padding-bottom: 16px;
            &__title {
                margin-left: 16px;
                font-size: 21px;
                letter-spacing: -0.86;
                line-height: 28px;
                color: rgba(black, 0.54);
                margin-bottom: 0;
            }

            &__card {
                margin-top: 8px;
                background: #ECEFF1;
                border-radius: 8px;
                width: calc(100% - 16px);
                margin: 8px 8px 0 8px;
                padding: 15px 16px 20px 16px;

                &__title {
                    font-weight: 500;
                    font-size: 21px;
                    line-height: 40px;
                    color: rgba(black, 0.87);
                    margin-bottom: 9px;
                }

                &__subtitle-container {
                    margin-bottom: 8px;
                }

                &__answer-container {
                    margin-bottom: 32px;
                }

                &__circle {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    font-weight: 700;
                    font-size: 14px;
                    text-align: center;
                    vertical-align: middle;
                    line-height: 24px;
                    flex-shrink: 0;
                    &.q {
                        background: #867CE9;
                        color: rgba(black, 0.87);
                    }
                    &.a {
                        background: rgba(black, 0.08);
                        color: #867CE9;
                    }
                }

                &__subtitle {
                    margin-left: 16px;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 24px;
                    color: #867CE9;
                }

                &__content-container {
                    margin-left: 16px;
                }

                &__content {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24px;
                    width: 100%;
                    color: rgba(black, 0.54);
                }

                &__toggle {
                    margin-top: -4px;
                    width: 100%;
                    &:hover {
                        cursor: pointer;
                    }

                    &__text {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #7C4DFF;
                        margin-left: 8px;
                    }
                }
            }
        }
    }
    }
</style>